import React, { Component } from "react";
import {
  Tag,
  Input
} from "antd";
const { TextArea } = Input;

import Footer from "../exercise/Footer";

class Question extends Component {
  constructor(props) {
    super(props);
  }

  state = {
    font: ''
  };

  componentDidMount() {
    const {
      data: {
        stem
      }
    } = this.props;

    try {
      const {
        content: fontList
      } = JSON.parse(stem);

      if (fontList.length) {
        const [ font ] = fontList;

        this.setState({
          font
        });
      }
    } catch (error) {}
  }

  createHtml = (str) => ({ __html: str ? str : `&nbsp;` });

  /**
   * 选中题目切换
   */
  handleSelectFont = font => {
    this.setState({
      font
    });
  }

  render() {
    let originData = this.props.data;
    const { num, index } = this.props;
    let data = {
      content: "unknown",
    };
    try {
      data = JSON.parse(originData.stem);
    } catch (error) {}

    const {
      content: fontList
    } = data;
    const {
      font
    } = this.state;

    const tagList = fontList.map(cur =>
      <Tag
        key={cur.questionName}
        color={cur.questionName === font.questionName ? '#108ee9' : ''}
        onClick={() => this.handleSelectFont(cur)}
        style={{padding: '0 20px'}}
      >
        {cur.questionName}
      </Tag>
    );

    return (
      <div className="box-exercise" ref={"viewer"}>
        <div className="exercise-content">
          {num !== "undefined" && (
            <div className="exercise-num">
              <p className="math_text">
                {index || index === 0
                  ? `${index + 1} - ${num + 1}`
                  : `${num + 1}、`}
              </p>
            </div>
          )}
          <div
            className="exercise-con"
          >
            <p className="math_text">
              {tagList}
            </p>
            <p className="math_picture">
              <span>题干图片：</span>
              <img
                src={font.questionImg}
                style={{width: '88px'}}
              />
            </p>
            <p className="math_text">
              <span>书写要点：</span>
              <TextArea
                rows={4}
                style={{ width: '280px' }}
                value={font.keyPoint}
              />
            </p>
            <p className="math_picture">
              <span>书写素材：</span>
              <img
                src={font.sourceMaterial}
                style={{width: '200px'}}
              />
            </p>
          </div>
        </div>
        <div className="exercise-footer">
          <div className="footer-show relative">
            <Footer
              {...this.props}
              obj={originData}
              subject={this.props.data.subject}
            ></Footer>
          </div>
        </div>
      </div>
    );
  }
}

export default Question;



// WEBPACK FOOTER //
// ./src/entry_question_editor/question/writingClass/viewForView.js